import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";

import { ACCESS_LEVELS, PERMISSION_AREAS } from "api/common/types/auth.types";
import { Product } from "api/memberPortal/project/product/product.types";
import ActionsCell from "components/MUI/DataGrid/Cells/Actions/Actions.cell";
import IconMenuItem from "components/MUI/DataGrid/Cells/Actions/IconMenuItem";
import { useAuth } from "hooks/useAuth";
import { checkPermissions } from "utils/permissions";

interface PidActionsCellProps {
  product: Product;
  handleShowProductFormModal: (_product: Product) => void;
  setShowDeleteModal: (_show: boolean) => void;
  setProduct: (_product: Product) => void;
  setProductDelete: (_product: Product) => void;
}

const PidActionsCell = ({
  product,
  handleShowProductFormModal,
  setShowDeleteModal,
  setProduct,
  setProductDelete,
}: PidActionsCellProps) => {
  const { permissions } = useAuth();

  const hasProductDestroyPermissions = checkPermissions({
    permissions,
    area: PERMISSION_AREAS.PROJECT,
    access: ACCESS_LEVELS.DESTROY,
  });
  const hasProductEditPermissions = checkPermissions({
    permissions,
    area: PERMISSION_AREAS.PROJECT,
    access: ACCESS_LEVELS.UPDATE,
  });

  return (
    <ActionsCell id={product.v_id || product.product_id}>
      <IconMenuItem
        Icon={EditIcon}
        label="Edit Draft"
        enabled={hasProductEditPermissions}
        onClick={() => {
          setProduct(product);
          handleShowProductFormModal(product);
        }}
      />
      <IconMenuItem
        Icon={DeleteIcon}
        label="Delete Draft"
        enabled={hasProductDestroyPermissions}
        onClick={() => {
          setProductDelete(product);
          setShowDeleteModal(true);
        }}
      />
    </ActionsCell>
  );
};

export default PidActionsCell;
